import { LoadingButton } from '@mui/lab'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField } from '@mui/material'
import { ExplanationAccordion } from 'components'
import { SettingsMissingOhioTitleAlertDto } from 'dtos'
import { missingOhioTitleAlertValidationSchema } from 'dtos/settingsMissingOhioTitleAlertDateDto'
import { Formik } from 'formik'

interface MissingOhioTitleAlertDateAddEditDialogProps {
  initialValues: SettingsMissingOhioTitleAlertDto
  open: boolean
  isLoading?: boolean
  onClose: () => void
  onSave: (values: SettingsMissingOhioTitleAlertDto) => void
}

export default function MissingOhioTitleAlertDateAddEditDialog({
  isLoading,
  initialValues,
  open,
  onClose,
  onSave
}: MissingOhioTitleAlertDateAddEditDialogProps) {
  return (
    <Dialog open={open}>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validateOnChange
        validateOnBlur
        validationSchema={missingOhioTitleAlertValidationSchema}
        onSubmit={(values, formikHelpers) => {
          onSave(values)
          formikHelpers.setSubmitting(false)
        }}
      >
        {({ errors, handleBlur, handleChange, handleSubmit, setFieldValue, isSubmitting, touched, values }) => {
          return (
            <form onSubmit={handleSubmit}>
              <DialogContent>
                <Grid container spacing={2} alignItems='center'>
                  <DialogTitle>Missing Ohio Title Alert Date</DialogTitle>

                  <Grid item xs={12}>
                    <TextField
                      disabled={isLoading || isSubmitting}
                      error={Boolean(
                        touched.missingOhioTitleAlertNumberOfDaysAfterTitleApplicationsDeliveredOhio &&
                          errors.missingOhioTitleAlertNumberOfDaysAfterTitleApplicationsDeliveredOhio
                      )}
                      helperText={
                        touched.missingOhioTitleAlertNumberOfDaysAfterTitleApplicationsDeliveredOhio &&
                        errors.missingOhioTitleAlertNumberOfDaysAfterTitleApplicationsDeliveredOhio
                      }
                      label='Days after Title Apps sent to Ohio'
                      name='missingOhioTitleAlertNumberOfDaysAfterTitleApplicationsDeliveredOhio'
                      onBlur={handleBlur}
                      onChange={handleChange}
                      type='number'
                      value={values.missingOhioTitleAlertNumberOfDaysAfterTitleApplicationsDeliveredOhio}
                    />
                  </Grid>
                </Grid>
                <Grid item xs={12} sx={{ mt: 2 }}>
                  <ExplanationAccordion variant='outlined'>
                    ||All fields are required. || After Ohio title application boxes are delivered to Ohio (this may be driven
                    off the FedEx API saying the box was delivered to Ohio), where the Title has not been added to the vehicle
                    (the Ohio title is mailed to the Registered Importer, the Ohio title is OCR’d and associated with the VIN)
                    send an alert email to all VTS2 users with the Receives “Missing Ohio Title” emails VTS2 Access. This is to
                    prevent the need for manual tracking of this information outside VTS2. ||
                  </ExplanationAccordion>
                </Grid>
              </DialogContent>

              <DialogActions>
                <Button color='inherit' disabled={isLoading || isSubmitting} onClick={onClose} variant='text'>
                  CANCEL
                </Button>

                <LoadingButton loading={isLoading || isSubmitting} type='submit' variant='contained'>
                  SAVE
                </LoadingButton>
              </DialogActions>
            </form>
          )
        }}
      </Formik>
    </Dialog>
  )
}
